import { LocationContext } from "@freightsimple/generated-dashboard-openapi-client/models/LocationContext";
import { LocationType } from "@freightsimple/generated-dashboard-openapi-client/models/LocationType";
import type {
  AccessorialType,
  UnscopedAccessorialType,
} from "@/Data/generateAccessorialTypes";
import { generateAccessorialTypes } from "@/Data/generateAccessorialTypes";

function getName(
  a: UnscopedAccessorialType,
  scope: LocationContext | undefined,
) {
  if (scope === LocationContext.Delivery) {
    return a.deliveryName;
  }

  if (scope === LocationContext.Pickup) {
    return a.pickupName;
  }

  if (scope === undefined || scope === LocationContext.Any) {
    return a.name;
  }

  throw new Error("Unhandled case");
}

function getDescription(
  a: UnscopedAccessorialType,
  scope: LocationContext | undefined,
) {
  if (scope === LocationContext.Delivery) {
    return a.deliveryDescription;
  }

  if (scope === LocationContext.Pickup) {
    return a.pickupDescription;
  }

  if (scope === undefined || scope === LocationContext.Any) {
    return a.description;
  }

  throw new Error("Unhandled case");
}

export function scopeAccessorials(
  scope: LocationContext | undefined,
  locationType: LocationType | undefined,
): Array<AccessorialType> {
  const unscoped = generateAccessorialTypes(locationType).filter((o) => {
    if (scope === LocationContext.Pickup) {
      if (o.type === "SCHEDULING_APPOINTMENT_REQUIRED") {
        return false;
      }
    }

    return true;
  });

  return unscoped.map((a) => ({
    name: getName(a, scope),
    description: getDescription(a, scope),
    type: a.type,
    comingSoon: a.comingSoon,
    unavailable: a.unavailable,
    questionBubble: a.questionBubble,
  }));
}
